import { atom } from 'jotai'

export const locationFormattedStringAtom = atom('')
